import { Icon } from '@chakra-ui/react';

export const CopyAddressIcon = ({ width }: { width: string }) => {
	return (
		<Icon
			w={width}
			h={width}
			viewBox="0 0 17 17"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M14.2216 6.48193H7.92161C7.14841 6.48193 6.52161 7.10874 6.52161 7.88194V14.1819C6.52161 14.9552 7.14841 15.582 7.92161 15.582H14.2216C14.9948 15.582 15.6216 14.9552 15.6216 14.1819V7.88194C15.6216 7.10874 14.9948 6.48193 14.2216 6.48193Z"
				stroke="#FF3F3F"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M3.72159 10.6821H3.02158C2.65028 10.6821 2.29418 10.5346 2.03163 10.272C1.76908 10.0094 1.62158 9.65335 1.62158 9.28205V2.98203C1.62158 2.61073 1.76908 2.25463 2.03163 1.99208C2.29418 1.72953 2.65028 1.58203 3.02158 1.58203H9.3216C9.6929 1.58203 10.049 1.72953 10.3115 1.99208C10.5741 2.25463 10.7216 2.61073 10.7216 2.98203V3.68204"
				stroke="#FF3F3F"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Icon>
	);
};
